import { useEffect, useRef, useState } from "react";
import { IoCheckmarkCircle } from "react-icons/io5";
import {
  getAllCleanerShifts,
  getuserinformation,
  savereminderdata,
  savevehicledata,
  updateItem,
} from "../../utils/firebasefunctions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { MdEditDocument, MdDelete } from "react-icons/md";
import userlogo from "../images/user.png";
import { RotatingLines } from "react-loader-spinner";
import { IoIosCloseCircle } from "react-icons/io";
import { actionType } from "../context/reducer";
import { ToastContainer, toast } from "react-toastify";
import { FaCircleMinus } from "react-icons/fa6";
import carlogo from "../images/car.png";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import { FaCar } from "react-icons/fa";
import {
  arrayUnion,
  collection,
  doc,
  onSnapshot,
  query,
} from "firebase/firestore";
import { firestored, storage } from "../../firebase.config";

import { useStateValue } from "../context/StateProvider";
import EmployeePopup from "./EmployeePopup";

const containerStyle = {
  width: "100%",
  minHeight: "100%",
};

const CurrentReminders = (props) => {
  const [{ user, employees }, dispatch] = useStateValue();
  const [employeedata, setemployeedata] = useState();
  const [employeepopup, setemployeepopup] = useState(false);
  const [remindertime, setremindertime] = useState("12:00");
  const [selectedemployee, setselectedemployee] = useState([]);
  const [taskloader, settaskloader] = useState(false);
  const [loader, setloader] = useState(false);

  const [newtask, setnewtask] = useState("");
  const [selecteddate, setselecteddate] = useState(new Date());

  const popupref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        props.activateoutsidecontainerclick();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupref]);

  const Heading = (title) => {
    return <p className="pt-[10px] PoppinsRegular  text-textcolor ">{title}</p>;
  };

  async function deletereminder(id, index) {
    let dataset = {
      delete: true,
    };
    await updateItem("reminders", id, dataset)
      .then(async (response) => {
        if (response == "success") {
          let newdata = [...props.data];
          newdata.splice(index, 1);
          props.updatereminders(newdata);
        } else {
          toast.warn("Something went wrong. Please try again later!");
        }
      })
      .catch((error) => {
        toast.warn("Something went wrong. Please try again later!");
      });
  }
  return (
    props.visible && (
      <div className="position absolute z-10  top-[0] left-[0] w-full h-full bg-[rgba(211,211,211,0.4)] flex items-center justify-center ">
        <div
          ref={popupref}
          className="w-[80%] lg:w-[900px]    bg-themelightblack border border-bordercolor  rounded-xl  gk-scr  flex items-center justify-center flex-col   h-[80%] md:h-[90%] px-[20px] "
        >
          <div className="flex w-full h-[100%] relative flex-col py-[20px]  overflow-scroll ">
            {Heading("Created Reminder's")}
            <div className=" overflow-x-auto  border border-bordercolor mt-5  bg-cardOverlay rounded-xl  drop-shadow-lg overflow-y-scroll m-h-[45%]">
              <table className="min-w-full divide-y divide-bordercolor bg-themelightblack text-sm">
                <thead className="ltr:text-left rtl:text-right">
                  <tr>
                    <th className="whitespace-nowrap py-2 px-2  PoppinsRegular text-textcolor"></th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Time
                    </th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor"></th>
                    <th className="whitespace-nowrap py-2 px-4  PoppinsRegular text-textcolor">
                      Reminder
                    </th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-bordercolor text-center">
                  {props.data &&
                    props.data.map(
                      (item, index) =>
                        !item.delete && (
                          <tr
                            key={index.toString()}
                            className="hover:bg-[#0989B826]/10 cursor-pointer h-[90px]"
                            onClick={() => {}}
                          >
                            <td className="whitespace-nowrap px-2 py-2 PoppinsRegular  ">
                              <MdDelete
                                onClick={() => {
                                  deletereminder(item.id, index);
                                }}
                                className=" text-lighttextGray hover:text-red-500   w-[20px] h-[20px] hover:cursor-pointer ml-[10px]"
                              />
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor pr-[20px]">
                              {moment(item.remindertimestamp).format(
                                "YYYY-MM-DD HH:mm",
                              )}
                            </td>
                            <td className="whitespace-nowrap px-4 py-2 PoppinsRegular  text-textcolor ">
                              <div className="flex flex-row ">
                                {employees
                                  .filter(
                                    (x) =>
                                      item.employeelist.find(
                                        (item) => item == x.id,
                                      ) != undefined,
                                  )
                                  .map((itemdata, ind) => {
                                    return (
                                      <img
                                        loading="lazy"
                                        style={{
                                          marginLeft: 5,
                                          //   marginLeft:
                                          //     employees.filter(
                                          //       (x) =>
                                          //         item.employeelist.find(
                                          //           (item) => item == x.id
                                          //         ) != undefined
                                          //     ).length > 1
                                          //       ? -50
                                          //       : 0,
                                        }}
                                        src={
                                          itemdata.profilepicture
                                            ? itemdata.profilepicture
                                            : userlogo
                                        }
                                        className="w-[35px] h-[35px] rounded-full object-cover"
                                      />
                                    );
                                  })}
                              </div>
                            </td>
                            <td className="whitespace-nowrap pl-4 py-2 PoppinsRegular  text-textcolor text-left ">
                              {item.remindernote}
                            </td>
                          </tr>
                        ),
                    )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default CurrentReminders;
